import { FormBase } from "../../util/form-base-form";
import { spinner } from "../../util/spinner/spinner";

/**
 * User Register Form
 * DOM getter/setter only
 */

export type UserRegisterPayload = {
    email: string;
    nickname: string;
    password: string;
};

export class UserRegisterForm extends FormBase {
    public form: HTMLFormElement;

    public emailInput: HTMLInputElement | null;

    public nicknameInput: HTMLInputElement | null;

    public passwordInput: HTMLInputElement | null;

    public submitButton: HTMLButtonElement | null;

    public constructor(form: HTMLFormElement) {
        super();
        this.form = form;

        this.emailInput = this.getInput(form, 'input[name="email"]');
        this.nicknameInput = this.getInput(form, 'input[name="nickname"]');
        this.passwordInput = this.getInput(form, 'input[name="password"]');

        this.submitButton = this.getButton(form, 'button[type="submit"]');
    }

    public getPayload(): UserRegisterPayload {
        return {
            email: (this.emailInput?.value || "").trim(),
            nickname: (this.nicknameInput?.value || "").trim(),
            password: this.passwordInput?.value || "",
        };
    }

    public clearPassword(): void {
        if (this.passwordInput) {
            this.passwordInput.value = "";
        }
    }

    public resetForm(): void {
        this.form.reset();
    }

    public setSubmitting(isSubmitting: boolean): void {
        if (!this.submitButton) return;

        this.submitButton.setAttribute("aria-busy", isSubmitting ? "true" : "false");
        if (isSubmitting) {
            spinner.showButtonLoader(this.submitButton, { translateKey: "spinner_proccesing" });
            return;
        }

        spinner.hideButtonLoader(this.submitButton);
    }
}
